import React from "react";
import { InfringementsDashboard } from "../../components/infringements_dashboard.component";

export const InfringementsScreen = () => {
  return <InfringementsDashboard title="Live Infringements" />;
};
